import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';

const MissionVisionMottoList = () => {
    const { result, isLoading, setRefresh } = useFetch(() =>
        request.getAll('mission-vision-motto')
    );
    const navigate = useNavigate();

    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    console.log(result);

    const columns = [
        {
            name: 'Mission Message',
            wrap: true,
            center: 'true',
            selector: (row) => row?.mission_message,
        },
        {
            name: 'Vision Message',
            wrap: true,

            center: 'true',
            selector: (row) => row?.vision_message,
        },
        {
            name: 'Motto Message',
            wrap: true,
            center: 'true',
            cell: (row) => <div>{row?.motto_message}</div>,
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Action',
            center: 'true',
            cell: (row) => (
                <div>
                    <EditButton
                        onClick={() =>
                            navigate(`/dashboard/website/mission-vision-motto/edit/${row?.id}`)
                        }
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // delete function

    const abotUsDeleteHandler = () =>
        request.delete('mission-vision-motto', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Mission , Vision & Motto List'
            buttonTitle='Add New '
            addButtonHandler={() => navigate('/dashboard/website/mission-vision-motto/add')}
        >
            <ReactDataTable columns={columns} data={result} pending={isLoading} />

            {/* delete about us */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={abotUsDeleteHandler}
                />
            )}
        </CardLayout>
    );
};

export default MissionVisionMottoList;
